export default axios => ({
  createAccessRequest: (payload) => axios.post('contact/access-request', payload).then(r => r.data || {})
})
